class ScrollReveal {
  constructor(element) {
    this.element = element;
    this.mount();
  }

  mount() {
    this.bindSetttings();
    this.bindObserver();
  }

  bindSetttings() {
    this.observer = null;
    this.options = {
      rootMargin: '0px',
      threshold: 0,
    };
  }

  bindObserver() {
    this.observer = new IntersectionObserver(this.observerCallback, this.options);
    this.observer.observe(this.element);
  }

  observerCallback(entries) {
    document.body.classList.add('has-scroll-reveal');

    entries.forEach((entry) => {
      const el = entry.target;
      const delay = el.getAttribute('animate-delay') || 50;

      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('isVisible');
        }, delay);

        if (el.hasAttribute('animate-up-children')) {
          const children = el.querySelectorAll('[animate-up-child]');
          let staggerDelay = delay;

          const offset = (x) => {
            let tempOffset = 200;
            for (let i = 0; i <= x; i++) {
              tempOffset = tempOffset * 0.85;
            }
            return tempOffset;
          };

          children.forEach((child, index) => {
            if (index != 0) {
              staggerDelay = offset < 1 ? staggerDelay : parseInt(staggerDelay) + offset(index);
            }

            setTimeout(() => {
              child.classList.add('isVisible');
            }, staggerDelay);
          });
        }
      }
    });
  }
}
export default ScrollReveal;
